export { default as NewRequestTemplate } from "./NewRequestTemplate";
export { default as PendingRequestsTemplate } from "./PendingRequestsTemplate/index";
export { default as RequestReviewTemplate } from "./RequestReviewTemplate";
export { default as ApprovedRequestsTemplate } from "./ApprovedRequestsTemplate";
export { default as AgreementTemplate } from "./AgreementTemplate";
export { default as RequestDetailsTemplate } from "./RequestDetailsTemplate";
